
require('./pages');
require('./staff');
require('./post');